export class PartnershipVM {
  cityName!: string;
  logoPath!: string;
  constructor(cityName: string, logoPath: string) {
    this.cityName = cityName;
    this.logoPath = logoPath;
  }
}
